<template>
  <div class="Holiday">
    <CCard title="Tìm kiếm" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <h4>Tìm kiếm</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow>
          <CCol sm="3" />
          <CCol sm="3">
            <CSelect label="Năm" :options="dataYear" :value.sync="valueYear" />
          </CCol>
          <CCol sm="3" style="padding-top:25px">
            <vs-button
              warn
              square
              class="custom_btn_search float-left"
              @click="searchTK()"
            >
              <i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button
            >
            <vs-button
              v-if="CheckRole(32) === true"
              square
              class="float-left"
              @click="AddHoliday()"
            >
              <i class="bx bxs-plus-square"></i>&nbsp;Thêm mới</vs-button
            >
          </CCol>
          <CCol sm="3" />
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mb-2">
      <vue-good-table
        :columns="columns"
        :rows="dataTK"
        compactMode
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          nextLabel: 'Trang sau',
          prevLabel: 'Trang trước',
          ofLabel: 'của',
          perPage: 20,
        }"
        :search-options="{
          enabled: false,
          placeholder: 'Tìm kiếm',
        }"
        :line-numbers="true"
        :sort-options="{
          enabled: false,
        }"
      >
        <div slot="emptystate">
          Không có dữ liệu
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'action'" class="center">
            <vs-tooltip color="danger">
              <template #tooltip>
                Xoá
              </template>
              <vs-button
                v-if="CheckRole(32) === true"
                transparent
                @click="DeleteHoliday(props.row.id)"
                danger
                circle
                icon
              >
                <i class="bx bx-trash"></i
              ></vs-button>
              <!-- <CButton
                    :disabled="valueLockALL"
                    :class="classDuyet"
                    color="danger"
                    @click="ConfirmTimKeeping(props.row)"
                    ><i class="bx bx-check-circle"></i>
                  </CButton> -->
            </vs-tooltip>
          </div>
          <div v-else-if="props.column.field === 'status'">
            <CBadge v-if="props.row.lock == 1" color="success">Đã khoá</CBadge>
            <CBadge
              v-if="props.row.status == 1 && props.row.lock != 1"
              color="success"
              >Đã duyệt</CBadge
            >
            <CBadge
              v-else-if="props.row.status != 1 && props.row.lock != 1"
              color="warning"
              >Chờ duyệt</CBadge
            >
          </div>
        </template>
      </vue-good-table>
    </CCard>

    <vs-dialog prevent-close v-model="activeAddHoliday">
      <template #header>
        <h4 class="not-margin">
          <b>Thêm ngày nghỉ</b>
        </h4>
      </template>
      <div class="con-form">
        <CRow class="mb-12">
          <CCol sm="6">
            <span class="font-bold">Ngày nghỉ</span>
            <b-form-datepicker
              id="datepicker"
              v-model="add_day"
              class="mb-2 mt-2"
              locale="vi"
              placeholder="Ngày nghỉ"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              :hide-header="true"
              label-help=""
              :value-as-date="true"
            ></b-form-datepicker>
          </CCol>
          <CCol sm="6">
            <CInput label="Ghi chú" placeholder="" v-model="add_note" />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <div class="footer-dialog">
          <vs-button block @click="SubmitHoliday">
            Thêm
          </vs-button>
        </div>
      </template>
    </vs-dialog>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from "vue-good-table";
const timekeepingApi = ClientFactory.get("timekeepings");
const departmentApi = ClientFactory.get("departments");
import moment from "moment";

export default {
  components: {
    VueGoodTable,
  },
  data: () => ({
    activeAddHoliday: false,
    add_day: "",
    add_note: "",

    columns: [
      {
        label: "ID",
        field: "id",
        hidden: true,
      },
      {
        label: "Năm",
        field: "year",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "Ngày nghỉ",
        field: "holiday",
        thClass: "text-center",
      },
      {
        label: "Ghi chú",
        field: "note",
        thClass: "text-center",
      },
      {
        label: "Thao tác",
        field: "action",
        sortable: false,
        width: "100px",
        thClass: "text-center",
      },
    ],
    rows: [
      {
        session: "<button>My Action</button>",
        // ...
      },
    ],

    dataTK: [],

    valueYear: new Date().getFullYear(),
    dataYear: [
      {
        label: new Date().getFullYear() + 1,
        value: new Date().getFullYear() + 1,
      },
      {
        label: new Date().getFullYear(),
        value: new Date().getFullYear(),
      },
      {
        label: new Date().getFullYear() - 1,
        value: new Date().getFullYear() - 1,
      },
      {
        label: new Date().getFullYear() - 2,
        value: new Date().getFullYear() - 2,
      },
    ],
  }),
  created() {
    this.searchTK();
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    searchTK: async function() {
      this.loading(this.$vs);
      const params = {
        year: this.valueYear,
      };
      console.log(params);
      const result = await timekeepingApi.get_holiday(params);

      this.checkResponseData(result);
    },

    async AddHoliday() {
      this.loading(this.$vs);
      this.activeAddHoliday = true;
      this.closeLoading();
    },

    async SubmitHoliday() {
      this.loading(this.$vs);
      let body = {};
      body.holiday = moment(this.add_day).format("DD/MM/YYYY");
      body.note = this.add_note;

      const result = await timekeepingApi.add_holiday(body);
      console.log(result);
      if (
        typeof result.error !== "undefined" ||
        result.data.status === "failed" ||
        result.status === "failed"
      ) {
        this.closeLoading();
        return this.notify({
          error: true,
          text: result.error || result.message,
        });
      } else {
        this.closeLoading();
        this.searchTK();
        this.activeAddHoliday = false;
        this.add_note = "";
        return this.notify({
          text: result.data[0].error_message,
        });
      }
      this.closeLoading();
    },

    async DeleteHoliday(id) {
      let body = {};
      body.id = id;
      console.log(body);
      const result = await timekeepingApi.delete_holiday(body);
      console.log(result);
      if (result.status == "success") {
        this.searchTK();
        this.notify({ text: result.data[0].error_message });
      } else {
        this.notify({ error: true, text: result.message });
        this.searchTK();
      }
    },
    checkResponseData: function(data) {
      if (data.status == "success") {
        this.dataTK = data.data;
      } else {
        this.dataTK = [];
      }
      this.closeLoading();
    },

    CheckRole(id) {
      return this.AppActiveUser.role.includes(id);
    },

    showloading: function() {
      this.loading();
      setTimeout(() => {
        this.closeLoading();
      }, 2000);
    },
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
  },
};
</script>

<style lang="scss">
.Holiday {
  table.vgt-table td {
    vertical-align: inherit;
    padding: 0em 0.75em 0em 0.75em;
  }
  .tk-width-class {
    min-width: 10px !important;
    text-align: center;
  }
  .tk-name-class {
    min-width: none;
    -width: 250px !important;
  }

  .tk-month-class {
    min-width: none;
    -width: 80px !important;
  }

  .visible {
    visibility: visible !important;
  }
  .invisible {
    visibility: hidden !important;
  }
  .tk-status-class {
    min-width: 100px;
    text-align: center;
  }
  .tk-action-class {
    min-width: 150px;
    text-align: center;
  }
}
</style>
